import { store } from '@user/store/store'
import {
  divisionDisplayName,
  selectDivisionById,
} from '@user/store/divisions/slice'

export const divisionValueFormatter = (divisionId: string | null): string => {
  if (typeof divisionId === 'string') {
    const div = selectDivisionById(store.getState(), divisionId)
    return !!div ? divisionDisplayName(div) : ''
  }
  return ''
}
